"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Location = _interopRequireDefault(require("../../geom/Location"));

var _EdgeEnd2 = _interopRequireDefault(require("../../geomgraph/EdgeEnd"));

var _Position = _interopRequireDefault(require("../../geomgraph/Position"));

var _GeometryGraph = _interopRequireDefault(require("../../geomgraph/GeometryGraph"));

var _Label = _interopRequireDefault(require("../../geomgraph/Label"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _Edge = _interopRequireDefault(require("../../geomgraph/Edge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var EdgeEndBundle =
/*#__PURE__*/
function (_EdgeEnd) {
  _inherits(EdgeEndBundle, _EdgeEnd);

  function EdgeEndBundle() {
    var _this;

    _classCallCheck(this, EdgeEndBundle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EdgeEndBundle).call(this));
    EdgeEndBundle.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(EdgeEndBundle, [{
    key: "insert",
    value: function insert(e) {
      this._edgeEnds.add(e);
    }
  }, {
    key: "print",
    value: function print(out) {
      out.println("EdgeEndBundle--> Label: " + this._label);

      for (var it = this.iterator(); it.hasNext();) {
        var ee = it.next();
        ee.print(out);
        out.println();
      }
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this._edgeEnds.iterator();
    }
  }, {
    key: "getEdgeEnds",
    value: function getEdgeEnds() {
      return this._edgeEnds;
    }
  }, {
    key: "computeLabelOn",
    value: function computeLabelOn(geomIndex, boundaryNodeRule) {
      var boundaryCount = 0;
      var foundInterior = false;

      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        var loc = e.getLabel().getLocation(geomIndex);
        if (loc === _Location.default.BOUNDARY) boundaryCount++;
        if (loc === _Location.default.INTERIOR) foundInterior = true;
      }

      var loc = _Location.default.NONE;
      if (foundInterior) loc = _Location.default.INTERIOR;

      if (boundaryCount > 0) {
        loc = _GeometryGraph.default.determineBoundary(boundaryNodeRule, boundaryCount);
      }

      this._label.setLocation(geomIndex, loc);
    }
  }, {
    key: "computeLabelSide",
    value: function computeLabelSide(geomIndex, side) {
      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();

        if (e.getLabel().isArea()) {
          var loc = e.getLabel().getLocation(geomIndex, side);

          if (loc === _Location.default.INTERIOR) {
            this._label.setLocation(geomIndex, side, _Location.default.INTERIOR);

            return null;
          } else if (loc === _Location.default.EXTERIOR) this._label.setLocation(geomIndex, side, _Location.default.EXTERIOR);
        }
      }
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this._label;
    }
  }, {
    key: "computeLabelSides",
    value: function computeLabelSides(geomIndex) {
      this.computeLabelSide(geomIndex, _Position.default.LEFT);
      this.computeLabelSide(geomIndex, _Position.default.RIGHT);
    }
  }, {
    key: "updateIM",
    value: function updateIM(im) {
      _Edge.default.updateIM(this._label, im);
    }
  }, {
    key: "computeLabel",
    value: function computeLabel(boundaryNodeRule) {
      var isArea = false;

      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        if (e.getLabel().isArea()) isArea = true;
      }

      if (isArea) this._label = new _Label.default(_Location.default.NONE, _Location.default.NONE, _Location.default.NONE);else this._label = new _Label.default(_Location.default.NONE);

      for (var i = 0; i < 2; i++) {
        this.computeLabelOn(i, boundaryNodeRule);
        if (isArea) this.computeLabelSides(i);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeEndBundle;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return EdgeEndBundle;
}(_EdgeEnd2.default);

exports.default = EdgeEndBundle;

EdgeEndBundle.constructor_ = function () {
  this._edgeEnds = new _ArrayList.default();

  if (arguments.length === 1) {
    var e = arguments[0];
    EdgeEndBundle.constructor_.call(this, null, e);
  } else if (arguments.length === 2) {
    var boundaryNodeRule = arguments[0],
        _e = arguments[1];

    _EdgeEnd2.default.constructor_.call(this, _e.getEdge(), _e.getCoordinate(), _e.getDirectedCoordinate(), new _Label.default(_e.getLabel()));

    this.insert(_e);
  }
};